module.exports = __webpack_public_path__ + "img/pickleball.a569381e.svg";